import { PopupConfirmComponent } from './popup-confirm.component';

export default angular
  .module('sfMobile.components.popup-confirm', [
    'sfMobile.components.popup-icon',
  ])
  .component('sfPopupConfirm', PopupConfirmComponent).name;
